import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import TransposedTableFromServer from "../../../Components/Table/TransposedTableFromServer";
import { useGetToken } from '../../../Hooks/CustomHooks';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import * as Utilities from '../../../Components/Utils/Utils';

export default function AfluenciaMensualParking({ title }) {

    // const [date, setDate] = useState(moment().subtract(2, 'year').toDate());
    // let dateFormated = moment(date).toDate().toLocaleString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' });

    const [año1, setAño1] = useState(new Date());
    let dateFormated1 = año1.getFullYear();

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas(true);

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for CharFromServer
        setUnidadEconomica(inputValue);
    }

    let transposedSettings = {
        type: ["float", "float", "percentage", "percentage"],
        hightlighted: [false, false, false, false],
        rowsClasses: [],
        rowsSpan: [1, 1, 1, 1],
        firstColumn: [
            dateFormated1,
            dateFormated2,
            "% " + dateFormated2 + " vs. " + dateFormated1,
            "% " + dateFormated2 + " mes anterior",
            "Variación"
        ]
    }
    registerLocale("es", es);

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.AFLUENCIA_MENSUAL_PARKING]} >
                <PageTitle>{title}</PageTitle>
                
                <div className="card my-5">
                    <div className='card-header border-0 pt-5'>
                        <div className="d-flex flex-wrap flex-stack mb-6">
                            <div className="d-flex flex-wrap my-2">
                                <div className="p-2" style={{ minWidth: "200px" }}>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                    <Select
                                        classNamePrefix='filter'
                                        components={animatedComponents}
                                        defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                        isMulti={false}
                                        closeMenuOnSelect={true}
                                        options={unidadesEconomicasList.list}
                                        onChange={(onChangeGraphType)}
                                    />
                                </div>
                                <div className='p-2'>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Año Reporte:</div>
                                    <DatePicker
                                        className="form-control form-control-transparent pe-5"
                                        locale="es"
                                        selected={año1}
                                        onChange={(dateX) => dateX && setAño1(dateX)}
                                        dateFormat="yyyy"
                                        showYearPicker
                                        minDate={Utilities.add_years(new Date(), -6)}
                                        maxDate={new Date()}
                                    />
                                </div>
                                <div className='p-2'>
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                                    <DatePicker
                                        className="form-control form-control-transparent pe-5"
                                        locale="es"
                                        selected={año2}
                                        onChange={(dateX) => dateX && setAño2(dateX)}
                                        dateFormat="yyyy"
                                        showYearPicker
                                        minDate={Utilities.add_years(new Date(), -6)}
                                        maxDate={new Date()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-body tab-content pt-0">
                        <TransposedTableFromServer
                            idContent={"AfluenciaMensualParking " + dateFormated1 + " " + dateFormated2 + "1"}
                            header={[{ Header: 'Año', accessor: dateFormated1 + "", headerClassName: 'text-gray-800 mb-1' }]}
                            setAuxData={null}
                            apiService={Api.AfluenciaMensualParking}
                            args={{ anio1: dateFormated1, anio2: dateFormated2, unidadEconomica: unidadEconomica.value, token: useGetToken() }} // * para filters
                            conditions={true}
                            hideFilter={true}
                            pgSize={15}
                            hidePagination={true}
                            fileNameDownload={"Reporte Afluencia Mensual Parking - " + dateFormated1 + " " + dateFormated2 + "1"}
                            transposedSettings={transposedSettings}
                            frecuency={"Mensual"}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}